import React from 'react';
import { X } from 'lucide-react';
interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPurchase: () => void;
}
export function InfoModal({
  isOpen,
  onClose,
  onPurchase
}: InfoModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in" data-id="element-1">
      <div className="bg-gradient-to-b from-brand-dark to-brand-brown border border-brand-gold/50 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto shadow-2xl relative animate-scale-in" data-id="element-2">
        <button onClick={onClose} className="absolute top-4 right-4 text-brand-cream/70 hover:text-brand-cream transition-colors p-1" aria-label="Cerrar" data-id="element-3">
          <X size={24} data-id="element-4" />
        </button>

        <div className="p-6 sm:p-8" data-id="element-5">
          <h3 className="font-playfair text-2xl font-bold text-brand-gold mb-6 pr-8 leading-tight" data-id="element-6">
            ¿Qué incluye el Mega Pack?
          </h3>

          <div className="space-y-6 font-inter text-brand-cream text-sm" data-id="element-7">
            <div data-id="element-8">
              <h4 className="font-bold text-brand-gold mb-3 text-base border-b border-brand-gold/20 pb-2" data-id="element-9">
                TOMOS (6):
              </h4>
              <ul className="space-y-2.5" data-id="element-10">
                <li className="flex gap-2 items-start" data-id="element-11">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-12">1)</span>
                  <span data-id="element-13">Tomo 1: Diagnóstico, Niveles y Planificación</span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-14">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-15">2)</span>
                  <span data-id="element-16">Tomo 2: Mapa del diapasón para enseñar</span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-17">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-18">3)</span>
                  <span data-id="element-19">
                    Tomo 3: Improvisación Rock/Mixta — Pentatónica "sobre los
                    cambios"
                  </span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-20">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-21">4)</span>
                  <span data-id="element-22">Tomo 4: Acompañamiento armónico moderno</span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-23">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-24">5)</span>
                  <span data-id="element-25">Tomo 5: Reharmonización y recursos armónicos</span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-26">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-27">6)</span>
                  <span data-id="element-28">
                    Tomo 6: Arreglos y repertorio docente — Chord Melody +
                    Texturas
                  </span>
                </li>
              </ul>
            </div>

            <div data-id="element-29">
              <h4 className="font-bold text-brand-gold mb-3 text-base border-b border-brand-gold/20 pb-2" data-id="element-30">
                BONOS (3):
              </h4>
              <ul className="space-y-2.5" data-id="element-31">
                <li className="flex gap-2 items-start" data-id="element-32">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-33">1)</span>
                  <span data-id="element-34">Bono 1: 30 Planes de Clase Listos (60')</span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-35">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-36">2)</span>
                  <span data-id="element-37">Bono 2: Evaluaciones + Rúbricas + Seguimiento</span>
                </li>
                <li className="flex gap-2 items-start" data-id="element-38">
                  <span className="text-brand-gold font-bold shrink-0" data-id="element-39">3)</span>
                  <span data-id="element-40">Bono 3: Banco de Recursos Docente (Rock/Mixto)</span>
                </li>
              </ul>
            </div>
          </div>

          <button onClick={onPurchase} className="w-full bg-brand-orange text-white font-inter font-bold text-lg py-4 rounded-xl mt-8 shadow-[0_0_15px_rgba(232,114,12,0.4)] hover:shadow-[0_0_20px_rgba(232,114,12,0.6)] hover:scale-[1.02] transition-all duration-200" data-id="element-41">
            Adquirir Ahora por $19.990 →
          </button>
        </div>
      </div>
    </div>;
}